export const PX_PER_MM = 96 / 25.4;

export function pxToMm(px: number): number {
  return Number((px / PX_PER_MM).toFixed(1));
}

export function mmToPx(mm: number): number {
  return mm * PX_PER_MM;
}

export function clamp(n: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, n));
}
